'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeRoomDiscoveredEquipment = {
    fromJson: fromJson,
    getRoomDiscoveredEquipment: getRoomDiscoveredEquipment,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseObject.$fromJson(data, 'RoomDiscoveredEquipment', reqProps, reqProps,
        function(data) { return getRoomDiscoveredEquipment(data.$roomId); }
    );
}

// Returns a promise that resolves to the RoomDiscoveredEquipment object when it is loaded.

function getRoomDiscoveredEquipment(roomId) {
    var key = 'RoomDiscoveredEquipment: ' + roomId;
    var config = KayleeCache.get(key);

    if (config === null) {
        config = new RoomDiscoveredEquipment(roomId);
        KayleeCache.put(key, config);
    }

    return config;
}

function RoomDiscoveredEquipment(roomId) {
    this.$nodeType = 'roomDiscoveredEquipment';
    this.$roomId = roomId;
    FirebaseObject.call(this, KayleeBase.app.database().ref('roomDiscoveredEquipment/' + roomId));
}

RoomDiscoveredEquipment.prototype = Object.create(FirebaseObject.prototype);
RoomDiscoveredEquipment.prototype.constructor = RoomDiscoveredEquipment;

RoomDiscoveredEquipment.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$roomId' ], {});
};

RoomDiscoveredEquipment.prototype.toString = function() {
    return '[RoomDiscoveredEquipment (' + this.$id + ')]';
};

module.exports = KayleeRoomDiscoveredEquipment;
